import { UTCDateMini } from '@date-fns/utc';
import { DirectlyObservedTherapyDto, TherapyDtoTherapyResult } from '../api/generated/model';

type DirectlyObservedTherapyValue =
  | DirectlyObservedTherapyDto
  | DirectlyObservedTherapyDto[]
  | null
  | undefined;

export function getDirectlyObservedTherapy(
  directlyObservedTherapy?: DirectlyObservedTherapyValue,
): DirectlyObservedTherapyDto | null {
  if (!directlyObservedTherapy) {
    return null;
  }

  if (Array.isArray(directlyObservedTherapy)) {
    return directlyObservedTherapy[0] ?? null;
  }

  return directlyObservedTherapy;
}

export function hasDirectlyObservedTherapy(directlyObservedTherapy?: DirectlyObservedTherapyValue): boolean {
  return getDirectlyObservedTherapy(directlyObservedTherapy) !== null;
}

export function calculateTherapyProgress(start: string, end: string): number {
  const dateStart = new UTCDateMini(start).getTime();
  const dateEnd = new UTCDateMini(end).getTime();
  const today = UTCDateMini.now();

  if (today < dateStart) return 0;
  if (today > dateEnd) return 100;

  return ((today - dateStart) / (dateEnd - dateStart)) * 100;
}

export function getTherapyResultName(result: TherapyDtoTherapyResult) {
  switch (result) {
    case TherapyDtoTherapyResult.THERAPY_INTERRUPTION:
      return 'Therapieunterbruch';
    case TherapyDtoTherapyResult.DEATH:
      return 'Todesfall';
    case TherapyDtoTherapyResult.REFERRAL:
      return 'Überweisung an:';
    case TherapyDtoTherapyResult.THERAPY_UNKNOWN_RESULT:
      return 'Unbekanntes Behandlungsresultat';
    case TherapyDtoTherapyResult.THERAPY_COMPLETED:
      return 'Therapie abgeschlossen';
    case TherapyDtoTherapyResult.THERAPY_FAILED_CLINICAL_TEST:
      return 'Therapieversagen, weil Behandlung klinisch nicht anspricht oder Kulturen positiv bleiben';
    case TherapyDtoTherapyResult.THERAPY_FAILED_MEDICATION_SIDE_EFFECTS:
      return 'Therapieversagen, weil unerwünschte Wirkungen auf die Medikamente aufgetreten sind';
    case TherapyDtoTherapyResult.THERAPY_FAILED_LABORATORY_RESISTANCE:
      return 'Therapieversagen, weil das Labor Resistenzen meldet';
    case TherapyDtoTherapyResult.HEALED_LUNG_TB:
      return 'Geheilte Lungentuberkulose';
    case TherapyDtoTherapyResult.NO_TB:
      return 'Keine Tuberkulose';
    case TherapyDtoTherapyResult.PENDING:
      return 'Ausstehend';
  }
}
